import {
    SERVERS_UPDATE_ACTIVE,
    SERVERS_UPDATE_SERVERLIST,
    SERVERS_SET_SERVER_STATUS,
    SERVERS_SET_ENABLED_LIST,
    SERVERS_SET_PROFILES,
} from '../constants'

export function actionServersSetActiveServer(name) {
    return {
        type: SERVERS_UPDATE_ACTIVE,
        payload: name,
    }
}

export function actionServersSetServerList(servers) {
    return {
        type: SERVERS_UPDATE_SERVERLIST,
        payload: servers,
    }
}

export function actionServersSetServerStatus(status) {
    return {
        type: SERVERS_SET_SERVER_STATUS,
        payload: status,
    }
}

export function actionServersSetEnabledServers(enabledServers) {
    return {
        type: SERVERS_SET_ENABLED_LIST,
        payload: enabledServers,
    }
}

export function actionServersSetProfiles(server, profiles) {
    return {
        type: SERVERS_SET_PROFILES,
        payload: { server, profiles },
    }
}



// WEBPACK FOOTER //
// ./src/actions/servers.js